<template>
  <Modal
    :title="$t('hausefulInvoices.modals.upload.title')"
    name="SEND_HOST_INVOICE_MODAL"
  >
    <template v-slot:body>
      <v-row>
        <v-col cols="8">
          <h6 class="text-uppercase grey--text">{{ $t('hausefulInvoices.headers.customer') }}</h6>
          <p class="mb-0 body-2">{{ branchName() }}</p>
          <p class="grey--text caption mb-0">{{ branchCnpj() }}</p>
        </v-col>
        <v-col cols="4">
          <h6 class="text-uppercase grey--text text-right">{{ $t('hausefulInvoices.headers.total') }}</h6>
          <p class="body-2 text-right mb-0">{{ branchTotal() }}</p>
        </v-col>
      </v-row>
      <HUploading v-if="isHostUserInvoiceLoading" class="my-5" />
      <HUpload @change="sendInvoice" small />
    </template>
  </Modal>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'
import { catalogMonetary } from '@/util/catalog'
import { maskCnpj } from '@/util/masks'

import Modal from '@/components/app/Modal'
import HUpload from '@/components/lib/HUpload'
import HUploading from '@/components/app/HUploading'

export default {
  name: 'ModalSendHostInvoice',

  components: {
    Modal,
    HUpload,
    HUploading,
  },

  props: {
    invoice: {
      type: Object,
      required: false,
    },
  },

  computed: {
    ...mapGetters(['isHostUserInvoiceLoading']),
  },

  methods: {
    ...mapMutations(['closeAllModals']),
    ...mapActions(['createHostUserInvoice']),

    branchName() {
      return this.invoice?.branch?.name ?? '---'
    },

    branchCnpj() {
      return this.invoice?.branch?.cnpj ? maskCnpj(this.invoice?.branch?.cnpj) : '---'
    },

    branchTotal() {
      return this.invoice?.branch?.total ? catalogMonetary(this.invoice?.branch?.total) : '---'
    },

    sendInvoice(file) {
      const invoiceData = {
        invoice_id: this.invoice.invoice_id,
        payment_ids: this.invoice.payment_ids,
        file: file[0],
      }

      this.createHostUserInvoice(invoiceData)
    },
  }
}
</script>
